import React, { Component } from "react";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import VehicleLoadItemEntry from "./VehicleLoadItemEntry";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import Progress from "./CustomTool/Progress";
import OrderSelection from "./OrderSelection";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  get_YMD_from_SYS,
  applyTrimOnObjectValues,
  validatedate_min_max,
  isValidItem,
  getRowData,
  getRoundOff,
  isCompanyChange,
} from "../SystemUtility/SystemUtility";
import { fetchLoadUnload } from "./API";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import StoreMaster from "./StoreMaster";

class VehicleLoadEntry extends Component {
  state = {
    LedgerNameList: [],
    StoreNameList: [],
    ResPerson: [],
    DriverName: [],
    dataToBeSet: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "vac_customer", label: "Customer" },
      { id: "vac_orderitemno", label: "Order Item No" },
      { id: "dat_orderdateDMY", label: "Order Date" },
      { id: "vac_storename", label: "Outward Store" },
      { id: "bint_itemsrno", label: "Item Sr. No." },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_hsncode", label: "HSN" },
      { id: "vac_unit", label: "Packing" },
      { id: "dec_loadqty", label: "Quantity" },
      { id: "dec_rate", label: "Rate" },
      { id: "dec_basicamt", label: "Basic Amt" },
      { id: "dec_disper", label: "Dis (%)", hide: true },
      { id: "dec_disamt", label: "Dis Amt", hide: true },
      { id: "dec_taxable", label: "Taxable", hide: true },
      { id: "vac_taxname", label: "Tax Name", hide: true },
      { id: "dec_cgstamt", label: "CGST", hide: true },
      { id: "dec_sgstamt", label: "SGST", hide: true },
      { id: "dec_igstamt", label: "IGST", hide: true },
      { id: "dec_totalamt", label: "Total Amount" },
      { id: "vac_remark", label: "Remark" },
    ],
    formData: {
      edit_loadingsrno: "",
      txtLoadingSrNo: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbLoadingStore: "",
      cmbDeliveryResponsiblePerson: "",
      int_status: 0,
    },
    keyColumn: [
      "bint_itemsrno", //0
      "vac_itemname", //1
      "vac_hsncode", //2
      "vac_unit", //3
      "dec_qty", //4
      "dec_rate", //5
      "dec_basicamt", //6
      "dec_disper", //7
      "dec_disamt", //8
      "dec_taxable", //9
      "vac_taxname", //10
      "dec_cgstamt", //11
      "dec_sgstamt", //12
      "dec_igstamt", //13
      "dec_totalamt", //14
      "vac_remark", //15
      "vac_storename", //16
      "vac_customer",
      "vac_orderitemno",
      "dat_orderdateDMY",
    ],
    searchData: {
      vac_customer: "",
      vac_orderitemno: "",
      dat_orderdateDMY: "",
      // bint_itemsrno: "", //0
      vac_itemname: "", //1
      // vac_hsncode: "", //2
      vac_unit: "", //3
      dec_qty: "", //4
      // dec_rate: "", //5
      // dec_basicamt: "", //6
      // dec_disper: "", //7
      // dec_disamt: "", //8
      // dec_taxable: "", //9
      // vac_taxname: "", //10
      // dec_cgstamt: "", //11
      // dec_sgstamt: "", //12
      // dec_igstamt: "", //13
      // dec_totalamt: "", //14
      vac_remark: "", //15
      vac_storename: "", //16
    },
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    OrderselectionVisible: false,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Load Entry";
    this.props.setActiveMenu("LoadEntry");
    this.setSearchColumns();
    this.onFormLoad();
    // this.props.verifyUserID(
    //   this.getInfo,
    //   this.props.navInfo.subMenuMaster,
    //   this.props.setSubMenu_Master_Entry,
    //   this.props.setUserPrivileges
    // );
  }
  //#endregion Component

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      // console.log("this.props.location", this.props.location);
      // console.log("this.props.location.state", this.props.location.state);
      let bint_acyear = 0,
        bint_acid = 0,
        edit_loadingsrno = 0;
      if (this.props.location.state && this.props.location.state != null) {
        // var editInfo = this.props.params.EditLoadingsSrNo.split(":");
        bint_acid = this.props.location.state.bint_acid;
        edit_loadingsrno = this.props.location.state.bint_loadingsrno;
        bint_acyear = this.props.location.state.bint_acyear;
      }
      let reqData = {
        Op: "LoadingData",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        edit_loadingsrno: edit_loadingsrno,
      };
      // console.log("edit_loadingsrno", edit_loadingsrno)
      fetchLoadUnload(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          let LedgerNameList = res.data.LedgerNameList,
            StoreNameList = res.data.StoreList;
          if (
            res.data.LoadingList &&
            res.data.LoadingList.length > 0 &&
            isCompanyChange(res.data.LoadingList[0].vac_company)
          ) {
            this.setState(
              {
                OrderselectionVisible: true,
                dataLoadStatus: true,
                StoreNameList,
                LedgerNameList,
                rows: res.data.ItemData,
                rowsCount: res.data.ItemData.length,
                formData: {
                  ...this.state.formData,
                  edit_loadingsrno: res.data.LoadingList[0].bint_loadingsrno,
                  txtLoadingSrNo: res.data.LoadingList[0].bint_loadingsrno,
                  dtpDate: res.data.LoadingList[0].dat_loaddate,
                  cmbLoadingStore: res.data.LoadingList[0].vac_storename,
                  cmbDeliveryResponsiblePerson:
                    res.data.LoadingList[0].vac_ledgername,
                  int_status: res.data.LoadingList[0].int_status,
                },
              },
              () => {
                // console.log("res.data.LoadingList[0].bint_loadingsrno", res.data.LoadingList[0].bint_loadingsrno)
              }
            );
          } else {
            this.setState(
              {
                dataLoadStatus: true,
                StoreNameList,
                LedgerNameList,
              },
              () => {
                // console.log(ReferenceList)
              }
            );
            // console.log(LedgerNameList)
          }
        })
        .catch((error) => {
          this.props.toastMsg(
            "error",
            "Unkonwn Error occured in onFormLoad. " + error
          );
        });
    });
    document.getElementById("dtpDate").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          edit_loadingsrno: "",
          txtLoadingSrNo: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          cmbLoadingStore: "",
          cmbDeliveryResponsiblePerson: "",
          int_status: 0,
        },
        rows: [],
        rowsCount: 0,
        OrderselectionVisible: false,
      },
      () => {
        document.getElementById("dtpDate").focus();
        this.props.navigateTo("VehicleLoadEntry");
      }
    );
  };

  saveLoadData = () => {
    if (this.validateLoadEntry() && this.validateLoadItemCount()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();

      this.setState({ dataLoadStatus }, () => {
        let GroupLedger = getRowData(
          this.state.LedgerNameList,
          "vac_ledgername",
          this.state.formData.cmbDeliveryResponsiblePerson
        );
        // console.log("GroupLedger", GroupLedger)
        const reqData = {
          Op: "SaveLoading_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_loadingsrno: this.state.formData.edit_loadingsrno,
          dat_loaddate: this.state.formData.dtpDate,
          vac_storename: this.state.formData.cmbLoadingStore,
          vac_groupname:
            GroupLedger.vac_groupname && GroupLedger.vac_groupname > 0
              ? GroupLedger.vac_groupname
              : "",
          vac_ledgername:
            this.state.formData.cmbDeliveryResponsiblePerson &&
            this.state.formData.cmbDeliveryResponsiblePerson.length > 0
              ? this.state.formData.cmbDeliveryResponsiblePerson
              : "",
          ItemData: [],
        };
        fetchLoadUnload(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState(
                {
                  dataLoadStatus: true,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Loading Data.", error);
          });
      });
    }
  };

  //#region Handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_customer.length === 0 ||
            (row["vac_customer"]
              ? row["vac_customer"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vac_customer.toLowerCase())
              : false)) &&
          (this.state.searchData.vac_orderitemno.length === 0 ||
            (row["vac_orderitemno"]
              ? row["vac_orderitemno"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vac_orderitemno.toLowerCase())
              : false)) &&
          (this.state.searchData.dat_orderdateDMY.length === 0 ||
            (row["dat_orderdateDMY"]
              ? row["dat_orderdateDMY"]
                  .toString()
                  .toLowerCase()
                  .includes(
                    this.state.searchData.dat_orderdateDMY.toLowerCase()
                  )
              : false)) &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"]
              ? row["vac_storename"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vac_storename.toLowerCase())
              : false)) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"]
              ? row["vac_itemname"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vac_itemname.toLowerCase())
              : false)) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"]
              ? row["vac_unit"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vac_unit.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_qty.length === 0 ||
            (row["dec_qty"]
              ? row["dec_qty"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.dec_qty.toLowerCase())
              : false)) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"]
              ? row["vac_remark"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vac_remark.toLowerCase())
              : false)) /*  &&
          (this.state.searchData.dec_basicamt.length === 0 ||
            (row["dec_basicamt"]
              ? row["dec_basicamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_basicamt.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_disper.length === 0 ||
            (row["dec_disper"]
              ? row["dec_disper"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_disper.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_disamt.length === 0 ||
            (row["dec_disamt"]
              ? row["dec_disamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_disamt.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_taxable.length === 0 ||
            (row["dec_taxable"]
              ? row["dec_taxable"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_taxable.toLowerCase())
              : false)) &&
          (this.state.searchData.vac_taxname === "ALL" ||
            this.state.searchData.vac_taxname === row["vac_taxname"]) &&
          (this.state.searchData.dec_cgstamt.length === 0 ||
            (row["dec_cgstamt"]
              ? row["dec_cgstamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_cgstamt.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_sgstamt.length === 0 ||
            (row["dec_sgstamt"]
              ? row["dec_sgstamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_sgstamt.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_igstamt.length === 0 ||
            (row["dec_igstamt"]
              ? row["dec_igstamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_igstamt.toLowerCase())
              : false)) &&
          (this.state.searchData.dec_totalamt.length === 0 ||
            (Number(row["dec_totalamt"])
              ? row["dec_totalamt"].includes(this.state.searchData.dec_totalamt)
              : false)) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (Number(row["vac_remark"])
              ? row["vac_remark"].includes(this.state.searchData.vac_remark)
              : false)) */
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {
          // console.log('searchRows on end of Function', searchRows)
        }
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnOrderSelection = () => {
    // this.props.navigateTo("VehicleLoadUnloadList");
    if (this.validateLoadEntry() === true) {
      let GroupLedger = getRowData(
        this.state.LedgerNameList,
        "vac_ledgername",
        this.state.formData.cmbDeliveryResponsiblePerson
      );
      // console.log("GroupLedger", GroupLedger)
      let vac_groupname = "";
      if (this.state.formData.cmbLedgername > 0) {
        vac_groupname = GroupLedger.vac_groupname;
      } else {
        vac_groupname = "";
      }
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            maxWidthClass={"1000px"}
            // alertTitle={'Sales Item Entry'}
            alertMessage={
              <OrderSelection
                SelectionFrom="Loading"
                bint_loadingsrno={this.state.formData.txtLoadingSrNo}
                dat_loaddate={this.state.formData.dtpDate}
                vac_storename={this.state.formData.cmbLoadingStore}
                vac_ledgername={
                  this.state.formData.cmbDeliveryResponsiblePerson
                }
                vac_groupname={vac_groupname}
                onSuccessfulOrderSelection={this.updateStateInfo}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };
  //#endregion Handle

  updateStateInfo = (rows) => {
    let count = 0;
    rows.map((row) => {
      if (count === 0) {
        count++;
        this.setState({
          formData: {
            ...this.state.formData,
            txtLoadingSrNo: row.bint_loadingsrno,
            edit_loadingsrno: row.bint_loadingsrno,
          },
          ARD: null,
          rows,
          rowsCount: rows.length,
          OrderselectionVisible: true,
        });
      }
    });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<VehicleLoadItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "vac_customer",
        label: "Customer",
        value: this.state.searchData.vac_customer,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_orderitemno",
        label: "Order Item No",
        value: this.state.searchData.vac_orderitemno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dat_orderdateDMY",
        label: "Order Date",
        value: this.state.searchData.dat_orderdateDMY,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_storename",
        label: "Outward Store",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "Item Sr no",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "HSN",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        label: "Packing",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_loadqty",
        label: "Quantity",
        value: this.state.searchData.dec_loadqty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "Rate",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Basic Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis (%)",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Tax Name",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "CGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "SGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "IGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Total Amount",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  validateLoadItemCount = () => {
    // this.props.toastErrorMsg("validateSalesItemCount")
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  trimFormData = (nextFunctionCall) => {
    // console.log("this.state.formData before SetSate", this.state.formData);
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      // console.log("this.state.formData After SetSate", this.state.formData);
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateLoadEntry = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Select Loading Date ", "dtpDate");
    } else if (this.state.formData.cmbLoadingStore.length <= 0) {
      this.props.toastErrorMsg("Select Loading Store", "cmbLoadingStore");
    } else if (
      !isValidItem(
        this.state.StoreNameList,
        "vac_storename",
        this.state.formData.cmbLoadingStore
      )
    ) {
      this.props.toastErrorMsg("Select Valid Store Name", "cmbLoadingStore");
    } else if (this.state.formData.cmbDeliveryResponsiblePerson.length <= 0) {
      this.props.toastErrorMsg(
        "Select Delivery Responsible Person",
        "cmbDeliveryResponsiblePerson"
      );
    } else if (
      !isValidItem(
        this.state.LedgerNameList,
        "vac_ledgername",
        this.state.formData.cmbDeliveryResponsiblePerson
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Delivery Responsible Person",
        "cmbLoadingStore"
      );
    } else {
      result = true;
    }
    return result;
  };

  updateStoreitemList = (StoreNameList) => {
    this.setState({ StoreNameList });
  };

  onAddClickStore = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <StoreMaster
              updateStoreitemList={this.updateStoreitemList}
              showHeading={true}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  onDeleteBtnClick = () => {
    // console.log("this.state.formData.edit_ordersrno", this.state.formData.edit_ordersrno)
    if (this.state.formData.edit_loadingsrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Loading Sr. No. : " +
              this.state.formData.edit_loadingsrno +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteLoadEntry(this.state.formData.edit_loadingsrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no Order to delete", "dtpDate");
    }
  };

  deleteLoadEntry = (edit_loadingsrno) => {
    if (edit_loadingsrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteLoadingEntry",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_loadingsrno: edit_loadingsrno,
          dat_fromdate: "",
          dat_todate: "",
          vac_storename: "",
        };
        fetchLoadUnload(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deleteLoadEntry. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no Load Entry records to delete."
      );
    }
  };

  render() {
    console.log(
      "this.state.formData.int_status",
      this.state.formData.int_status
    );
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Loading Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtTxt
                  id="txtLoadingSrNo"
                  label="Loading Sr. No."
                  defaultValue={this.state.formData.txtLoadingSrNo}
                  value={this.state.formData.txtLoadingSrNo}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Loading Date*"
                  width="170"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  accountYear={localStorage.getItem("ACY")}
                  value={this.state.formData.dtpDate}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbLoadingStore"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbLoadingStore"
                  label="Loading Store*"
                  items={this.state.StoreNameList}
                  value={this.state.formData.cmbLoadingStore}
                  handleOnChange={this.handleOnChange}
                  width={200}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  colID="vac_storename"
                  nextCtrlID="cmbDeliveryResponsiblePerson"
                  onAddClick={this.onAddClickStore}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbDeliveryResponsiblePerson"
                  label="Delivery Responsible Person*"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.cmbDeliveryResponsiblePerson}
                  onKeyDown={this.props.onKeyDown}
                  items={this.state.LedgerNameList}
                  colID="vac_ledgername"
                  width={400}
                  maxLength={100}
                />
              </Grid>
              <Grid
                item
                marginTop={1}
                display={this.state.OrderselectionVisible ? "none" : "block"}
              >
                <CtBtn
                  label="Order Selection"
                  onClick={this.handleOnOrderSelection}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid
                item
                display={
                  this.props.userPrivilege.Load == "R" ||
                  this.state.formData.int_status > 0
                    ? "none"
                    : "block"
                }
              >
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.saveLoadData();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} />
              </Grid>
              <Grid
                item
                display={
                  this.props.userPrivilege.Load !== "M" ? "none" : "block"
                }
              >
                <CtBtn label="Delete" onClick={this.onDeleteBtnClick} />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Loading List"
                  onClick={() => {
                    this.props.navigateTo("VehicleLoadUnloadList");
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          headRowFontColor="#ffffff"
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          // handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          // handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Order Item Entry"
        />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(VehicleLoadEntry))));
